import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { JoinedProduct } from '../document-creator/productGrid';

@Component({
  selector: 'app-create-customline',
  templateUrl: './create-customline.component.html',
  styleUrls: ['./create-customline.component.css']
})
export class CreateCustomlineComponent implements OnInit, OnDestroy {
  @Input() profitMargin: number = 0;
  @Output('newCustomLine') output = new EventEmitter<JoinedProduct>();
  customLine = new NewCustomLine();
  type: 'hour' | 'item' = 'hour';
  priceGroupSubscription: Subscription;
  priceGroups;
  currencyMask = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "",
    suffix: "",
    thousands: ".",
    nullable: false
  };
  constructor(private sharedData: SharedDataService) { }

  ngOnInit() {
    this.priceGroupSubscription = this.sharedData.priceGroups().subscribe((data) => { this.priceGroups = data })
  }

  ngOnDestroy() {
    this.priceGroupSubscription.unsubscribe();
  }

  switchPriceGroupForCustomLine() {
    if (this.customLine.priceGroupId != null) {
      let a = this.priceGroups.find(x => x.priceGroupId == this.customLine.priceGroupId);
      this.customLine.name = a.name;
      this.customLine.costPrice = a.costPrice;
      this.customLine.salesPrice = a.listPrice;
    }
  }

  createCustomLine() {
    if (this.customLine.costPrice == 0 && this.customLine.salesPrice != 0) {
      this.customLine.costPrice = this.customLine.salesPrice / ((this.profitMargin / 100) + 1);
    }
    this.output.emit(
      {
        'id': null,
        description: this.customLine.name,
        amount: this.customLine.amount,
        cost: this.customLine.costPrice,
        sale: this.customLine.salesPrice,
        totalCost: this.customLine.totalCostPrice(),
        totalSale: this.customLine.totalSalesPrice(),
        profit: +(((this.customLine.salesPrice - this.customLine.costPrice) / this.customLine.costPrice) * 100).toFixed(1),
        discount: 0,
        sortOrder: 0,
        companyProduct: false,
        number: '',
        image: '',
        wholesaler: '',
        manufacturer: '',
        type: 'custom',
        priceGroupId: this.customLine.priceGroupId,
        hideOnPdf:false
      }
    )
  }

  calcPrice(input) {
    if (input != 'sales' && this.customLine.costPrice > 0 && this.customLine.profit > 0) {
      this.customLine.salesPrice = this.customLine.costPrice * (1 + (this.customLine.profit / 100));
    }
    if (input == 'sales' && this.customLine.costPrice > 0) {
      this.customLine.profit = ((+this.customLine.salesPrice - this.customLine.costPrice) / this.customLine.costPrice) * 100;
    }
  }

}

export class NewCustomLine {
  name: string = '';
  costPrice: number = 0;
  profit: number = 0;
  salesPrice: number = 0;
  amount: number = 1;
  priceGroupId: string = null;
  check() {
    if (this.name != null && this.costPrice != null && this.salesPrice != null && this.amount != null && this.name != '' && this.amount != 0) {
      return false
    }
    else { return true }
  }
  reset() {
    this.name = '';
    this.costPrice = 0;
    this.profit = 0;
    this.salesPrice = 0;
    this.amount = 1;
    this.priceGroupId = null;
  }
  totalCostPrice() {
    return this.costPrice * this.amount
  }
  totalSalesPrice() {
    return this.salesPrice * this.amount
  }
}

